import { CustomColumn } from '../../../types/customColumn';

export const creditNoteProductColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'productId',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },

  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => {
      const { productCode, productName, categoryName } = row.original;
      return (
        <div className="text-sm leading-6">
          {/* Código del producto */}
          <div className="font-mono text-gray-500 dark:text-gray-400 text-xs">
            {productCode ? `(${productCode})` : '—'}
          </div>
          {/* Nombre */}
          <div className="font-medium text-black dark:text-white">
            {productName}
          </div>
          {/* Categoría (misma caja/clases, ahora en dos líneas) */}
          <div className="text-gray-600 dark:text-gray-400 mt-1 text-xs">
            <div>
              <strong>CATEGORÍA:</strong>
            </div>
            <div>{categoryName || '—'}</div>
          </div>
        </div>
      );
    },
  },

  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => {
      const { quantity, unitName, type } = row.original;

      return (
        <div className="text-sm leading-6">
          <div>
            {quantity.toFixed(2)} {unitName}
          </div>
          {type === 'RETURN' && (
            <div className="text-gray-600 dark:text-gray-400 text-xs">
              POR DEVOLUCIÓN
            </div>
          )}
          {type === 'DISCOUNT' && (
            <div className="text-gray-600 dark:text-gray-400 text-xs">
              POR DESCUENTO
            </div>
          )}
        </div>
      );
    },
  },

  {
    Header: 'Costo Unitario',
    accessor: 'unitCost',
    customCell: ({ row }) => {
      const { unitCost } = row.original;
      return <span>${Number(unitCost ?? 0).toFixed(2)}</span>;
    },
  },

  {
    Header: 'IVA Total',
    accessor: 'ivaAmount',
    customCell: ({ row }) => {
      const { ivaAmount } = row.original;
      return <span>${Number(ivaAmount ?? 0).toFixed(2)}</span>;
    },
  },

  {
    Header: 'Total Costo',
    accessor: 'totalAmount',
    customCell: ({ row }) => {
      const { totalAmount } = row.original;
      return <span>${Number(totalAmount ?? 0).toFixed(2)}</span>;
    },
  },

  {
    Header: 'Distribución',
    accessor: 'distributionPercent',
    customCell: ({ row }) => {
      const { distributionPercent, purchaseReferenceCode } = row.original;

      const percent = distributionPercent ?? 0; // Previene null o undefined

      return (
        <div className="text-sm leading-6">
          <div>{Number(percent).toFixed(8)}%</div>
          <div className="text-gray-600 dark:text-gray-400 mt-1 text-xs">
            CCF - {purchaseReferenceCode || '—'}
          </div>
        </div>
      );
    },
  },
];
